var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('Icon',{staticClass:"empty-icon",attrs:{"type":"zanwushuju"}}),_c('p',[_vm._v("暂无数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }